import React from 'react';
import { Box, TextField, Button, Typography, FormControl, Select, MenuItem } from '@mui/material';
import { createServiceContactDelegationService } from '../../../../Domain/Services/ServiceContactDelegation/CreateServiceContactDelegationService';
import { getServiceContactDelegation } from '../../../../Domain/Services/ServiceContactDelegation/GetServiceContactDelegationService';
import { patchServiceContactDelegationService } from '../../../../Domain/Services/ServiceContactDelegation/PatchServiceContactDelegationService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { useTranslation } from 'react-i18next';
import { PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE, PRIVATE_USER_LIST_DELEGATION_SERVICE, PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE } from '../../../Constants/PathsConstants';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PropTypes from "prop-types";
import InputLabel from "@mui/material/InputLabel";
import { toast } from 'react-toastify';
import { useParams, useNavigate } from "react-router-dom";
import { getServiceContractDelegationListService } from 'DelegationService/DelegationService/Domain/Services/ServiceContractDelegation/GetServiceContractDelegationListService';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { useLocation } from "react-router-dom";

FormServiceContactDelegationView.propTypes = {
    defaultContractId: PropTypes.number,
};


function FormServiceContactDelegationView() {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();
    const contractIdFromState = location.state?.contractId || null;
    const [contractId, setContractId] = React.useState("");
    const [serviceContactDelegationName, setServiceContactDelegationName] = React.useState("");
    const [apellido, setApellido] = React.useState("");
    const [correoElectronico, setCorreoElectronico] = React.useState("");
    const [contactPhoneNumber, setContactPhoneNumber] = React.useState("");
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [serviceContractDelegation, setServiceContractDelegation] = React.useState([]);
    const [idContrato, setIdContrato] = React.useState(null);
    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    const [errors, setErrors] = React.useState({ name: false, apellido: false, phone: false, email: false });
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);

    React.useEffect(() => {
        if (contractIdFromState) {
            setIdContrato(contractIdFromState);
        }
    }, [contractIdFromState]);


    console.log("ID Contrato:", idContrato);

    const resetForm = () => {
        setServiceContactDelegationName("");
        setContactPhoneNumber("");
    };
    const validateFields = () => {
        const newErrors = {
            name: !/^[a-zA-ZÀ-ÿ\s]{2,40}$/.test(serviceContactDelegationName.trim()),
            apellido: !/^[a-zA-ZÀ-ÿ\s]{2,40}$/.test(apellido.trim()),
            phone: !/^\+?[0-9]{9,15}$/.test(contactPhoneNumber.trim()),
            email: !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(correoElectronico.trim())
        };
        setErrors(newErrors);
        return !Object.values(newErrors).some(error => error);
    };

    React.useEffect(() => {
        getServiceContractDelegationListService()
            .then((response) => {
                if (Array.isArray(response.records)) {
                    setServiceContractDelegation(response.records);

                } else {
                    console.error("Error: Expected response.data to be an array", response);
                    setServiceContractDelegation([]);

                }
            }).catch((error) => {
                toast.error(t("serviceContractDelegation.table.no_data"));
                console.error("Error fetching contract service list:", error);
                setServiceContractDelegation([]);
            });
    }, []);

    const handleServiceContactDelegationNameChange = (event) => {
        setServiceContactDelegationName(event.target.value);
        if (errors.name) setErrors(prev => ({ ...prev, name: false }));
    };
    const handleServiceContractDelegationIdChange = (event) => {
        setContractId(event.target.value);
    };
    const handleContactApellidoChange = (event) => {
        setApellido(event.target.value);
        if (errors.apellido) setErrors(prev => ({ ...prev, apellido: false }));
    };
    const handleContactCorreoElectronicoChange = (event) => {
        setCorreoElectronico(event.target.value);
        if (errors.email) { setErrors(prev => ({ ...prev, email: false })) };
    };
    const handleContactPhoneNumberChange = (event) => {
        setContactPhoneNumber(event.target.value);
        if (errors.phone) setErrors(prev => ({ ...prev, phone: false }));
    };



    React.useEffect(() => {
        if (!id || id === "new") {
            // NUEVO CONTACTO
            setServiceContactDelegationName("");
            setApellido("");
            setCorreoElectronico("");
            setContactPhoneNumber("");
            setIdContrato(contractIdFromState || null);
            return;
        }

        // EDITAR CONTACTO
        setSendingApiRequest(true);

        getServiceContactDelegation(id)
            .then((response) => {
                if (response && response.name) {
                    setServiceContactDelegationName(response.name);
                    setApellido(response.apellido);
                    setCorreoElectronico(response.correoElectronico);
                    setContactPhoneNumber(response.contactPhoneNumber);

                    // PRIORIDAD: 1️⃣ contractIdFromState si viene desde contratos
                    //           2️⃣ id del contrato del contacto
                    const contratoIdFinal = contractIdFromState ?? response.serviceContractDelegation?.id ?? null;
                    setIdContrato(contratoIdFinal);
                    setContractId(contratoIdFinal);

                } else {
                    resetForm();
                }
            })
            .catch((error) => {
                toast.error(t("serviceContactDelegation.restore.error"));
                console.error(error);
                resetForm();
            })
            .finally(() => setSendingApiRequest(false));
    }, [id, contractIdFromState]);


    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateFields()) {
            toast.error(t("Revisa los campos marcados en rojo"));
            return;
        }
        if (sendingApiRequest) return;
        setSendingApiRequest(true);

        try {
            let apiResponse = null;
            if (id === 'new') {
                apiResponse = await createServiceContactDelegationService({
                    name: serviceContactDelegationName,
                    serviceContractDelegationId: parseInt(idContrato || contractId),
                    apellido: apellido,
                    correoElectronico: correoElectronico,
                    contactPhoneNumber: contactPhoneNumber
                });
                console.log("apiResponse", apiResponse);
            } else {
                apiResponse = await patchServiceContactDelegationService(id, {
                    name: serviceContactDelegationName,
                    serviceContractDelegationId: parseInt(idContrato || contractId),
                    apellido: apellido,
                    correoElectronico: correoElectronico,
                    contactPhoneNumber: contactPhoneNumber
                });
            }
            if (apiResponse !== null) {
                toast.success(t("serviceContactDelegation.save.success"));
                console.log(contractIdFromState);
                if (contractIdFromState) {
                    // Si vienes desde un contrato → vuelves al contrato
                    navigate(PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE);
                } else {
                    // Si vienes desde la lista global de contactos
                    navigate(PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE);
                }
            }
        } catch (error) {
            console.error("Error saving service contact delegation:", error);
        } finally {
            console.log("no se ha enviado la peticion");
            setSendingApiRequest(false);
        }
    };




    return (
        <>
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 3,
                    px: 2,
                }}
            >
                <Typography variant='h4' textAlign="center">
                    {id === "new" ? t('serviceContactDelegation.form.create') : t('serviceContactDelegation.form.update')}
                </Typography>
                <TextField
                    required
                    label={t('serviceContractDelegation.form.serviceContactName')}
                    variant="outlined"
                    helperText={errors.name ? t("Nombre no Valido: No poner numeros") : ''}
                    value={serviceContactDelegationName}
                    onChange={handleServiceContactDelegationNameChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />
                <FormControl sx={{ width: "100%", maxWidth: 400 }}>
                    <InputLabel>{t('serviceContactDelegation.form.contractName')}</InputLabel>
                    <Select

                        value={idContrato !== null ? idContrato : contractId !== undefined && contractId !== null ? contractId : ""}

                        onChange={handleServiceContractDelegationIdChange}
                        label={t('serviceContactDelegation.form.contractName')}
                    >
                        {serviceContractDelegation.map((contract) => (
                            <MenuItem key={contract.id} value={contract.id}>
                                {contract.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    required
                    label={t('Apellido')}
                    variant="outlined"
                    helperText={errors.apellido ? t("Apellido no Valido:No poner numeros") : ''}
                    value={apellido}
                    onChange={handleContactApellidoChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />
                <TextField
                    required
                    label={t('Correo Electronico')}
                    variant="outlined"
                    value={correoElectronico}
                    helperText={errors.email ? t('Introduce un correo válido (ejemplo@dominio.com)') : ''}
                    type="email"
                    onChange={handleContactCorreoElectronicoChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />
                <TextField
                    required
                    label={t('serviceContactDelegation.table.phoneNumber')}
                    variant="outlined"
                    helperText={errors.phone ? t("Telefono no Valido: ej:( + 34 634 866 763)") : ''}
                    value={contactPhoneNumber}
                    onChange={handleContactPhoneNumberChange}
                    sx={{ width: "100%", maxWidth: 400 }}
                />

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                        variant='contained'
                        color='error'
                        startIcon={<CancelIcon />}
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                        }}
                        onClick={() => {
                            if (contractIdFromState) {
                                navigate(PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE);
                            } else {
                                navigate(PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE);
                            }
                        }}
                    >
                        {t('serviceContactDelegation.form.cancel')}
                    </Button>

                    <Button
                        variant="contained"
                        type="submit"
                        startIcon={<SaveIcon />}
                        sx={{
                            backgroundColor: "#0492D4",
                            color: "white",
                            fontWeight: 'bold',
                            borderRadius: 2,
                            textTransform: 'none',
                            "&:hover": {
                                backgroundColor: "#037bb5",
                            },
                        }}
                    >
                        {id === "new" ? t('serviceContactDelegation.form.create') : t('serviceContactDelegation.form.update')}
                    </Button>

                </Box>
            </Box >
            <DialogLoader open={sendingApiRequest} />
        </>
    );
}
export default FormServiceContactDelegationView;